export default __webpack_public_path__ + "static/media/add.94a3a397.svg";